import { 
    postData, 
    downloadFile,
    getDataWithParams,
    destroyData,
} from '@/store/api/method-mbkm'

const requestInit = {
    page: 1,
    show: 10,
    sortBy: null,
    sorting: null,
    search: null,
    semesterId: null,
}
const itemInit = {
    id: null,
    semester_id: null,
    study_course_name: null,
    study_program_name: null,
    lecture_name: null,
    type: null,
}

const evaluasiInit = {
    id: null,
    oad_id: null,
    note: null,
    registration_id: null,
    type: null,
    study_course_id: null,
    semester_id: null,
    page: 1,
    show: 10,
}

const evaluasiMahasiswaInit = {
    id: null,
    oad_id: null,
    note: null,
    registration_id: null,
    type: null,
    study_course_id: null,
    semester_id: null,
}

const initialState = () => ({
    msg: null,
    data: {},
    dataEvaluasi: {},
    dataEvaluasiMahasiswa: {},
    list: [],
    sc_info: null,
    nama_user_info: null,
    username_info: null,
    blobData: null,
    request: {...requestInit},
    item: {...itemInit},
    itemEvaluasi: {...evaluasiInit},
    itemEvaluasiMahasiswa: {...evaluasiMahasiswaInit},
    statusConfirmation: [
        {
            status: 0,
            label: 'Belum dikonfirmasi',
            type: 'danger'
        },
        {
            status: 1,
            label: 'Dikonfirmasi',
            type: 'success'
        }
    ]
})
const state = initialState
 
const getters = {
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getData: state => state.data || {},
    getDataEvaluasi: state => state.dataEvaluasi || {},
    getDataEvaluasiMahasiswa: state => state.dataEvaluasiMahasiswa || {},
    getRequest: state => state.request,
    getItem: state => state.item,
    getStatusConfirmation: state => (status) => state.statusConfirmation.find(x => x.status == status),
    getStudyCourseNameInfo: state => state.sc_info,
    getNamaUserInfo: state => state.nama_user_info,
    getNPMInfo: state => state.username_info,
    getItemEvaluasi: state => state.itemEvaluasi,
    getItemEvaluasiMahasiswa: state => state.itemEvaluasiMahasiswa,
    getBlobData: state => state.blobData
}

const actions = {
    resetRequest({commit}){
        commit('SET_REQUEST',{...requestInit})
    },
    resetItem({commit}){
        commit('SET_ITEM',{...itemInit})
    },
    resetItemEvaluasi({commit}){
        commit('SET_ITEM_EVALUASI',{...evaluasiInit})
    },
    resetItemEvaluasiMahasiswa({commit}){
        commit('SET_ITEM_EVALUASI_MAHASISWA',{...evaluasiMahasiswaInit})
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    setItemEvaluasi({commit}, value){
        commit('SET_ITEM_EVALUASI',{...value})
    },
    setItemEvaluasiMahasiswa({commit}, value){
        commit('SET_ITEM_EVALUASI_MAHASISWA',{...value})
    },
    async store({commit}, data) {
        try {
            const payload = {...data}
            delete payload.id
            const response = await postData('/evaluation',payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchDataOprec({commit, state}){
        try {
            const response = await getDataWithParams('/evaluation/list-oprec',state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchDataIsiEvaluasiForAdmin({commit}, data) {
        try {
            const url = `/evaluation/list-result/${data.study_course_id}/${data.semester_id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA_ISI_EVALUASI', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchDataIsiEvaluasiForMahasiswa({commit, state}, registrationId){
        try {
            const response = await getDataWithParams('/evaluation/mahasiswa/'+registrationId,state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA_ISI_EVALUASI_MAHASISWA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async update({commit}, data) {
        try {
            const url = `/evaluation/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async destroy({commit}, data) {
        try {
            const url = `/evaluation/${data.id}`
            const response = await destroyData(url);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async updateStatus({commit}, data) {
        try {
            const url = `/evaluation/update-status/${data.id}/${data.semester_id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async downloadEvaluasi({commit }, {study_course_id, semester_id, type}) {
        try {
            const url =  `/evaluation/cetak-evaluasi/${study_course_id}/${semester_id}`
            var response = await downloadFile(url)
            commit ('SET_BLOBDATA', {value: response.data, type: type})
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    resetState({commit}){
        commit('resetState')
    }
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, error) {
        state.msg = error?.data?.msg || 'Jaringan Bermasalah'
        state.status = error?.data?.status || 0
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_DATA_ISI_EVALUASI(state, response){
        state.dataEvaluasi = response.data
        state.sc_info = response.study_course_name
    },
    SET_DATA_ISI_EVALUASI_MAHASISWA(state, value){
        state.dataEvaluasiMahasiswa = value
    },
    SET_REQUEST(state, value){
        state.request = value
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
    SET_ITEM(state, value){
        state.item = value
    },
    SET_ITEM_EVALUASI(state, value){
        state.itemEvaluasi = value
    },
    SET_ITEM_EVALUASI_MAHASISWA(state, value){
        state.itemEvaluasiMahasiswa = value
    },
    SET_LIST(state, value){
        state.list = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
